<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'user',
};
</script>



// WEBPACK FOOTER //
// User.vue?6167fc54